import * as React from 'react';
import Modal from 'react-bootstrap/Modal';
import ReactPlayer from 'react-player';
import Card from 'react-bootstrap/Card';
import {Help} from './buttons';
import CardGroup from 'react-bootstrap/CardGroup';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import {Secondary} from './buttons';
import {Alert, Col, FormFile} from 'react-bootstrap';
import PulsoidClient from '../PulsoidClient';
import {Loader} from './Loader/Loader';

export const FileTypeVideo = 'Video';
export const FileTypeSound = 'Audio';

export class FilePickerModal extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.pulsoid = new PulsoidClient();
    this.state = {
      loaded: true,
      files: [],
    };
  }

  refreshFiles = () => {
    this.pulsoid.getGallery().then((res) =>
      this.setState({
        files: res.files.filter((file) => file.type === this.props.fileType),
      })
    );
    this.pulsoid.getPulsoidGallery().then((res) =>
      this.setState({
        pulsoid: res.files.filter((file) => file.type === this.props.fileType),
      })
    );
  };

  componentDidMount() {
    this.refreshFiles();
  }

  render() {
    return (
      <Modal
        size={'xl'}
        show={this.props.show}
        onHide={() => this.props.hide()}
      >
        <Modal.Header closeButton>
          <h1>Select {this.props.fileType.toLowerCase()}</h1>
        </Modal.Header>
        <Modal.Body>
          {this.state.loading && (
            <Loader
              loading={this.state.loading}
              description={'Loading files'}
            />
          )}
          <FileUploader
            pulsoid={this.pulsoid}
            handleFileUpload={() => this.refreshFiles()}
            fileType={this.props.fileType}
          />

          <h2>Your files</h2>
          <FilesGrid
            files={this.state.files}
            onChoose={(file) => {
              this.props.onChoose(file);
            }}
          />
          <span>&nbsp;</span>
          {this.state.pulsoid && (
            <>
              <h2>Pulsoid files</h2>
              <FilesGrid
                files={this.state.pulsoid}
                onChoose={this.props.onChoose}
              />
            </>
          )}
        </Modal.Body>
      </Modal>
    );
  }

  handleRemove = (fileId) => {
    this.pulsoid
      .removeFileFromGallery(fileId)
      .then(({files}) => this.setState({files}));
  };
}

const FilesGrid = ({files, onChoose}) => {
  return groupByThree(
    files
      .filter((file) => ReactPlayer.canPlay(file.url))
      .map((file) => {
        return (
          <Card>
            <Card.Header style={{textAlign: 'center'}}>{file.name}</Card.Header>
            <Card.Body>
              <Row
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <ReactPlayer
                  width={'18rem'}
                  height={'13rem'}
                  // loop={true}
                  muted={true}
                  // playing={true}
                  controls={true}
                  url={file.url}
                />
              </Row>
              &nbsp;
              <Row
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <Help onClick={() => onChoose(file)}>Select</Help>
                {/*&nbsp;*/}
                {/*<Help onClick={() => this.handleRemove(file.id)}>Remove</Help>*/}
              </Row>
            </Card.Body>
          </Card>
        );
      })
  ).map((group, index) => <CardGroup key={index}>{group}</CardGroup>);
};

const emptyCard = () => {
  return <Card border="light" style={{width: '18rem'}} />;
};

const groupByThree = (array) => {
  let metaArray = [];
  let innerArray = [];
  let first = true;
  array.forEach((value, index) => {
    if (index % 3 === 0) {
      if (first) {
        innerArray.push(value);
        first = false;
      } else {
        metaArray.push(innerArray);
        innerArray = [value];
      }
    } else {
      innerArray.push(value);
    }
  });

  let count = 3 - innerArray.length;
  for (var i = 1; i <= count; i++) {
    innerArray.push(emptyCard(innerArray.length + i));
  }
  metaArray.push(innerArray);

  return metaArray;
};

class FileUploader extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {loading: false, progress: 0};
  }

  handleAddNewFile = () => {
    let tt = this;
    this.setState({loading: true, error: false}, () => {
      try {
        var formData = new FormData();
        var imagefile = document.querySelector('#image');
        formData.append('file', imagefile.files[0]);
        if (imagefile.files[0]) {
          this.uploadWithProgress('/v2/api/file', formData, (percent) => {
            this.setState({progress: percent});
          })
            .then((res) => {
              console.log('res', res);
              return this.props.pulsoid.addFileToGallery(
                imagefile.files[0].name,
                res.fileUrl,
                this.props.fileType
              );
            })
            .then(() => {
              this.setState({loading: false, progress: 0});
              this.props.handleFileUpload();
            })
            .catch((err) => {
              console.log('err', err);
              if (err.response && err.response.status === 413) {
                this.setState({
                  loading: false,
                  progress: 0,
                  error:
                    '🤯 The file exceeds the 200MB limit. We recommend using WebM format with a smaller file size.',
                });
              } else {
                this.setState({
                  loading: false,
                  progress: 0,
                  error: '😞 File Upload Failed',
                });
              }
            });
        } else {
          this.setState({loading: false, error: '😞 File Upload Failed'});
        }
      } catch (e) {
        this.setState({loading: false, error: '😞 File Upload Failed'});
      }
    });
  };

  render() {
    return (
      <>
        <Form.Group as={Row} className="justify-content-md-center">
          <Col sm={8}>
            <FormFile
              onChange={() => {
                if (document.getElementById('image').files.length === 1) {
                  this.setState({
                    image: document.getElementById('image').files.item(0).name,
                    error: undefined,
                  });
                }
              }}
              id="image"
              label={
                this.state.image ? this.state.image : 'Choose file to upload...'
              }
              custom
            />
          </Col>
          <Col sm={3}>
            <Secondary onClick={this.handleAddNewFile}>Upload file</Secondary>
          </Col>
        </Form.Group>
        <Loader
          loading={this.state.loading}
          description={'Uploading file'}
          progress={this.state.progress}
        />
        {this.state.error && (
          <Col sm={7}>
            <Alert variant={'warning'}>{this.state.error}</Alert>
          </Col>
        )}
      </>
    );
  }

  uploadWithProgress(url, formData, onProgress) {
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open('POST', url);
      xhr.withCredentials = true; // same as fetch's `credentials: 'include'`

      // Track upload progress
      xhr.upload.onprogress = (e) => {
        if (e.lengthComputable) {
          const percentCompleted = Math.round((e.loaded * 100) / e.total);
          onProgress(percentCompleted);
        }
      };

      xhr.onload = () => {
        if (xhr.status >= 200 && xhr.status < 300) {
          // Assuming the server returns JSON with { fileUrl: string }
          resolve(JSON.parse(xhr.responseText));
        } else {
          reject({response: {status: xhr.status}});
        }
      };

      xhr.onerror = () => {
        reject({response: {status: xhr.status}});
      };

      xhr.send(formData);
    });
  }
}
